import { loadTossPayments } from "@tosspayments/payment-sdk";
import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import BackButton from "components/buttons/BackButton";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import style from "./PointPayment.module.css";
import { formatLocalDate } from "shared/utils/Utils";
import { toast } from "react-toastify";

function PointPayment(props) {
    const { id } = useParams();
    const { userName } = useContext(AuthContext);
    const location = useLocation();

    const inputRef = useRef();
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "50px",
        width: "90%",


    }
    const applyBtnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "50px",
        width: "20%",


    }
    const [isMounted, setMounted] = useState(false);
    const [point, setPoint] = useState(0);
    const [usedPoint, setUsedPoint] = useState(0);
    const [orderProducts, setOrderProducts] = useState();
    const [total, setTotal] = useState(0);
    const [amount, setAmount] = useState(0);

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let data = {}
            requester.findMemberPointById(data, (result) => {
                if (result.code === 0) {
                    setPoint(result.data.point);
                }

            })
        }
    }, [isMounted])


    useEffect(() => {
        if (location.state) {
            
            setOrderProducts(location.state.orderProducts);
            setTotal(location.state.amount);
            setAmount(location.state.amount);
        }
    }, [location])
    useEffect(() => {
        if (orderProducts) {
            
        }
    }, [orderProducts])

    const usedPointClick = () => {
        if (inputRef.current.getValue() > point) {
            toast.error("포인트가 부족합니다.", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            return; // 함수 종료
        }
        
        
        setUsedPoint(parseFloat(inputRef.current.getValue() ? inputRef.current.getValue() : 0));
        setTotal(amount - (inputRef.current.getValue() ? inputRef.current.getValue() : 0));
    }


    const addPointClick = (value) => {
        const currentValue = parseInt(inputRef.current.getValue(), 10) || 0;
        


        const newValue = currentValue + value; // 숫자 덧셈
        inputRef.current.setValue(newValue);
        
    }
    const onRechargeClick = async () => {
        if (usedPoint > point) {
            toast.error("포인트가 부족합니다.", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            return; // 함수 종료
        }
        const tossPayments = await loadTossPayments('test_ck_YZ1aOwX7K8mdPGEkP9qryQxzvNPG');

        try {
            const paymentData = {
                amount: total,
                orderId: location.state && location.state.id,
                orderName: orderProducts[0] && orderProducts[0].productName + ' 외 ' + (orderProducts.length - 1),
                customerName: '홍길동',
                successUrl: `http://localhost:3000/ws/root/payment/gateway?type=product&usedPoints=${usedPoint ? usedPoint : 0}`,
                failUrl: "http://puffu.co.kr/ws/root/main",
            };
            tossPayments.requestPayment('CARD', paymentData);
        } catch (error) {
            console.error(error);
            // 에러 처리 로직
        }
    }

    return (

        <div style={{ position: "relative", height: "100vh" }}>
            <VerticalFlex gap={15}>
                <FlexChild width={"100%"} height={"initial"}>
                    <VerticalFlex>
                        <FlexChild padding={"10px 0"}>
                            <Center>
                                <P size={20} color={"black"}>결제 확인</P>
                            </Center>
                            <Dummy width={"30px"} />
                        </FlexChild>
                        <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D0D0D0"} />
                    </VerticalFlex>
                </FlexChild>
                {
                    orderProducts &&
                        orderProducts.length > 0
                        ?
                        orderProducts.map((data, index) => (
                            <FlexChild width={"90%"} height={"initial"}>
                                <div>
                                    <VerticalFlex gap={15}>
                                        <FlexChild height={"max-content"}>
                                            <HorizontalFlex>
                                                <FlexChild width={"30%"}>
                                                    <img src={data.productImg} width={"50%"} />
                                                </FlexChild>
                                                <FlexChild>
                                                    <VerticalFlex>
                                                        <FlexChild>
                                                            <Center textAlign={"left"} width={"100%"}>
                                                                <P>{data.productName} X{data.quantity}</P>
                                                            </Center>
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <Center textAlign={"left"} width={"100%"}>
                                                                <P font={"gmarketSansBold"}>{data.price ? (data.price * data.quantity).toLocaleString() : "0"}원</P>
                                                            </Center>
                                                        </FlexChild>
                                                    </VerticalFlex>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        {
                                            index !== 2 &&
                                            <FlexChild width={"100%"} height={"1px"} backgroundColor={"#D9D9D9"} />
                                        }

                                    </VerticalFlex>
                                </div>
                            </FlexChild>

                        ))
                        :
                        <FlexChild height={"initial"}>
                            <P>주문내역이 없습니다.</P>
                        </FlexChild>
                }
                <FlexChild width={"90%"} height={"initial"}>
                    <VerticalFlex gap={15}>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                                <P size={18}>포인트 사용</P>
                            </Center>
                        </FlexChild>
                        <FlexChild>
                            <InputText ref={inputRef} numberOnly point gray mobileText placeHolder={"사용할 포인트를 입력해주세요."} />
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild width={"90%"} height={"initial"}>
                    <Center width={"100%"} textAlign={"right"}>
                        <Inline>
                            <P>보유 포인트 : </P>
                            <P weight={"bold"} color={"var(--main-color)"}>{point && point} 원</P>
                        </Inline>
                    </Center>
                </FlexChild>
                <FlexChild height={"initial"}>
                    <div className={style.applyBtnWrap}>
                        <CustomButton onClick={usedPointClick} text={"적용"} style={applyBtnStyle} />
                    </div>
                </FlexChild>
                <FlexChild height={"initial"} width={"90%"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                                <P size={16}>상품합계</P>
                            </Center>
                        </FlexChild>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"right"}>
                                <P weight={"bold"} size={20}>{amount ? amount.toLocaleString() : 0}원</P>
                            </Center>
                        </FlexChild>
                    </HorizontalFlex>

                </FlexChild>
                <FlexChild height={"initial"} width={"90%"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                                <P size={16}>포인트사용</P>
                            </Center>
                        </FlexChild>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"right"}>
                                <P weight={"bold"} size={20}>{usedPoint ? usedPoint.toLocaleString() : 0}원</P>
                            </Center>
                        </FlexChild>
                    </HorizontalFlex>

                </FlexChild>
                <FlexChild height={"initial"} width={"90%"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                                <P size={16}>총 결제금액</P>
                            </Center>
                        </FlexChild>
                        <FlexChild>
                            <Center width={"100%"} textAlign={"right"}>
                                <P weight={"bold"} size={20}>{total ? total.toLocaleString() : 0}원</P>
                            </Center>
                        </FlexChild>
                    </HorizontalFlex>

                </FlexChild>
            </VerticalFlex>
            <div className={style.btnWrap}>1
                <CustomButton text={"결제하기"} style={btnStyle} onClick={onRechargeClick} />
            </div>
        </div>


    );
}

export default PointPayment;